import { createGlobalStyle } from 'styled-components';
import 'antd/dist/antd.less';
import '@ant-design/flowchart/dist/index.css';

export const GlobalStyles = createGlobalStyle`
  html {
    font-size: ${props => props.theme.font.size};
  }
  body {
    font-family: ${props => props.theme.font.family};
    font-style: ${props => props.theme.font.style};
    font-size: ${props => props.theme.font.size};
    color: ${props => props.theme.palette.common.black};

    margin: 0;
  }

  ::-webkit-scrollbar {
      width: 0.6rem;
      height: 0.6rem;

      &-thumb {
        border-radius: ${props => props.theme.borderRadius.normal};
        background-color: ${props => props.theme.palette.scrollBar};
      }
    }
`;
